import React from 'react';
export function Svg(props) {
  return <img alt="icon" src={props.src} {...props} />;
}
